// Glass Morphism Theme Constants
export const glassTheme = {
  // Gradient backgrounds
  gradients: {
    primary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    admin: 'linear-gradient(135deg, rgba(255, 107, 107, 0.15) 0%, rgba(238, 90, 36, 0.15) 100%)',
    adminHover: 'linear-gradient(135deg, rgba(255, 107, 107, 0.2) 0%, rgba(238, 90, 36, 0.2) 100%)',
  },

  // Glass effects
  glass: {
    background: 'rgba(255, 255, 255, 0.08)',
    backgroundHover: 'rgba(255, 255, 255, 0.12)',
    backgroundDense: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.15)',
    borderLight: '1px solid rgba(255, 255, 255, 0.1)',
    borderStrong: '1px solid rgba(255, 255, 255, 0.2)',
    backdropFilter: 'blur(20px)',
    backdropFilterLight: 'blur(10px)',
    shadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 8px 32px rgba(0, 0, 0, 0.2)',
    shadowLight: 'inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 4px 16px rgba(0, 0, 0, 0.15)',
    shadowHover: 'inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 8px 24px rgba(0, 0, 0, 0.25)',
  },

  // Colors for different states
  colors: {
    // Text colors
    textPrimary: 'white',
    textSecondary: 'rgba(255, 255, 255, 0.7)',
    textTertiary: 'rgba(255, 255, 255, 0.6)',
    textMuted: 'rgba(255, 255, 255, 0.5)',

    // Alert colors
    error: {
      background: 'rgba(211, 47, 47, 0.1)',
      border: '1px solid rgba(211, 47, 47, 0.3)',
      icon: 'rgba(255, 107, 107, 0.9)',
    },
    info: {
      background: 'rgba(33, 150, 243, 0.1)',
      border: '1px solid rgba(33, 150, 243, 0.3)',
      icon: 'rgba(144, 202, 249, 0.9)',
    },
    success: {
      background: 'rgba(76, 175, 80, 0.15)',
      border: '1px solid rgba(76, 175, 80, 0.3)',
      icon: 'rgba(129, 199, 132, 0.9)',
    },
    warning: {
      background: 'rgba(255, 152, 0, 0.1)',
      border: '1px solid rgba(255, 152, 0, 0.3)',
      icon: 'rgba(255, 183, 77, 0.9)',
    },
  },

  // Spacing
  spacing: {
    mobile: {
      padding: 2,
      paddingDense: 1,
      paddingLarge: 3,
      gap: 1,
      gapLarge: 2,
    },
    desktop: {
      padding: 3,
      paddingDense: 2,
      paddingLarge: 5,
      gap: 2,
      gapLarge: 3,
    },
  },

  // Border radius
  borderRadius: {
    small: '6px',
    medium: '8px',
    large: '16px',
    xlarge: '24px',
  },

  // Typography
  fontSize: {
    mobile: {
      h1: '1.8rem',
      h2: '1.5rem',
      h3: '1.3rem',
      h4: '1.1rem',
      body1: '0.9rem',
      body2: '0.8rem',
      caption: '0.7rem',
    },
    desktop: {
      h1: '2.5rem',
      h2: '2rem',
      h3: '1.75rem',
      h4: '1.25rem',
      body1: '1rem',
      body2: '0.875rem',
      caption: '0.75rem',
    },
  },

  // Transitions
  transitions: {
    fast: '200ms',
    standard: '300ms',
    slow: '500ms',
    easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
};

export default glassTheme;